import vizStoryCount from './viz-story-count/vizStoryCount';
import vizPitchPercentage from './viz-pitch-percentage/vizPitchPercentage';
import vizPitchAcceptance from './viz-pitch-acceptance/vizPitchAcceptance';
import vizMeadianDeadlineMiss from './viz-median-deadline-miss/vizMedianDeadlineMiss';
import keyStatsTemplate from './keyStats.html';

const toLoad = [
  vizStoryCount,
  vizPitchPercentage,
  vizPitchAcceptance,
  vizMeadianDeadlineMiss
];

/**
 * @author Umer Hassan
 */

function directive() {
  return {
    restrict: 'E',
    scope: {
      filterSet: '='
    },
    template: keyStatsTemplate
  };
}

export default function (ngModule) {
  ngModule.directive('keyStats', directive);
  toLoad.forEach((component) => {
    component(ngModule);
  });
}
